import React from "react";
import styled from "styled-components";
import {
  Select,
  TextField,
  Checkbox,
  FormControlLabel,
} from "@material-ui/core";

export const CheckboxLabel = styled(FormControlLabel)`
  display: block;
`;

export const StyledSelect = styled(Select)`
  background: ${(props) => props.theme.color.white.regular} !important;
  border-radius: 4px;

  select {
    padding: 10px 14px;
    padding-right: 40px;
    font-size: 14px;
    line-height: 14px;
  }

  svg {
    width: 1.5rem;
    height: 1.5rem;
    color: rgba(0, 0, 0, 0.87);
    margin-right: 7px;
  }
`;

export const StyledTextField = styled(TextField)`
  background: ${(props) => props.theme.color.white.regular} !important;
  border-radius: 4px;

  input {
    color: #222 !important;
    padding: 10px 14px;
    padding-right: 0;
    font-size: 14px;
    line-height: 14px;
  }
`;

export const StyledFormControlLabel = styled(FormControlLabel)`
  & span {
    font-size: 13px !important;
    line-height: 16px;
  }
  display: block;
  margin-top: 0em;
  margin-bottom: -0.25em;
`;

export const StyledCheckbox = styled(Checkbox)`
  padding: 4px 4px;
  margin-left: 5px;
  margin-right: 5px;
  & .MuiIconButton-label {
    position: relative;
  }
  & .MuiIconButton-label::before {
    content: " ";
    display: block;
    z-index: 1;
    position: absolute;
    background: white !important;
    top: 3.25px;
    left: 3.25px;
    bottom: 3.25px;
    right: 3.25px;
    border-radius: 2px;
  }
  & svg {
    z-index: 10;
  }
`;

export const Label = styled.label`
  ${(props) => props.theme.font_size.xxsmall};
  text-transform: uppercase;
  margin-bottom: 1rem;
  display: block;
`;
